import { getDayDifference, formatTime } from "@/helpers/Time";
import { Reservation } from "@/types/Reservation";
import { computed, ComputedRef, ref, Ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { useProfileStore } from "@/store/Profile";

interface reservationHook {
  startTime: Ref<string>;
  endTime: Ref<string>;
  pastDays: Ref<string>;
  futureDays: Ref<string>;
  reservationTitle: ComputedRef<string>;
  pending: Ref<null | boolean>;
}

export const useReservation = (reservation: Ref<Reservation>): reservationHook => {
  const { t } = useI18n();
  const profileStore = useProfileStore();

  const endTime = ref("");
  const startTime = ref("");

  const pastDays = ref("");
  const futureDays = ref("");

  const reservationTitle = computed(() => {
    return reservation.value.title ? reservation.value.title : t("noTitleFallback");
  });

  const pending = ref();

  function calculate() {
    if (!reservation.value) return;

    startTime.value = formatTime(reservation.value.startTime, profileStore.tabletTimeFormat);
    endTime.value = formatTime(reservation.value.endTime, profileStore.tabletTimeFormat);

    const startDelta = getDayDifference(new Date(), reservation.value.startTime);
    const endDelta = getDayDifference(new Date(), reservation.value.endTime);

    pastDays.value = startDelta !== 0 ? `${startDelta}d` : "";
    futureDays.value = endDelta !== 0 ? `+${endDelta}d` : "";

    pending.value = reservation.value.pending;
  }

  watchEffect(calculate);

  return {
    startTime,
    endTime,
    pastDays,
    futureDays,
    reservationTitle,
    pending,
  };
};
